<template>
  <div id="admin">

    <transition name="fadeLogin" appear>
    <div>
    <ul>
      <li>Username : <input type="text" name="username" v-model="username" placeholder="Username" /></li>
      <li>Password : <input type="password" name="password" v-model="password" placeholder="Password" /></li>
      <li><button type="button" class="loginButton" v-on:click="getUser()">Login</button></li>
    </ul>
    </div>
    </transition>

    <div v-if="dbres!='PASS'" class="errorMessage"><p>{{ dbres }}</p></div>
    <div v-if="dbres==='PASS'">
      <div class="chooseOption">
          <button class="addNew" v-on:click="AddNew()">ADD ENTRY</button>
          <button class="editOld" v-on:click="EditOld()">EDIT ENTRY</button>
      </div>

    <div v-if="toChoose">
      <div>

        <div class="chooseEntry">
        <button v-on:click="SetTable('activities')">Activities</button>
        <button v-on:click="SetTable('projects')">Projects</button>
        <button v-on:click="SetTable('education')">Education</button>
        </div>

        <ul>
          <li v-for="object in all" v-bind:key="object.ID" class="listGrid">
            <button class="listName" v-on:click="SetData(object)">{{object.Name}}</button>
            <button class="listDelete" v-on:click="DeleteRow(object.MAIN_ID,object.Type,object.ID)">Delete?</button>
          </li>
        </ul>

      </div>
    </div>

    <!-- state {{sharedState.getIsNew()}}
    hi{{sharedState.getRowData()}} -->

  <div v-if="allowed">
      <AddData />
  </div>
</div>
</div>
</template>

<script>
import axios from "axios";
import {store} from "../store.js";
import AddData from "@/views/addData.vue";

export default {
  data() {
    return {
      username: null,
      password: null,
      dbres: null,
      toChoose: false,
      allowed:false,      
      all: null,
      path: null,
      getTable:null,
      sharedState : store,
      canEnter:null
    };
  },
  methods: {
    getUser() {
      if (this.username != null && this.password != null) {
        const formData = new FormData();
        formData.append("user", this.username);
        formData.append("pass", this.password);
        axios
          .post(store.getphpPath() + "loginDBtry.php", formData)
          .then(response => {
            // console.log(response.data);
            this.dbres = response.data;
          })
          .catch(error => {
            // console.log("OOOOPS");
            console.log(error);
          });
        }
      },
    fullInfo() {
      axios
        .get(store.getphpPath() + "DBtry.php", {
          params: {
            type: "full",
            table: this.getTable,
            rowID: "*"
          }
        })
        .then(response => {
          this.all = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    DeleteRow(RowID,Type,ID){
       if (confirm('Are you really really sure you want to remove this row?')){
        const formData = new FormData();
        formData.append("RowID", RowID);
        formData.append("Type", Type);
        formData.append("ID", ID);
        axios
          .post(store.getphpPath() + "deleteRow.php", formData)
          .then(response => {
            // console.log(response.data);
            this.fullInfo();
          })
          .catch(error => {
            console.log(error);
          });
       }
      },
    SetTable(TableName){
        this.getTable=TableName;
        this.fullInfo();
        },
    SetData(Entry){
      store.setEntry(Entry);
      this.toChoose=false;
      this.allowed=true;
        },
    AddNew(){
      store.setEntryDeafult();
      this.allowed=true;
      this.toChoose=false;
        },
    EditOld(){
      this.toChoose=true;
      this.allowed=false;
      this.all = null;
    }

  },
  components: {
    AddData
  }
};
</script>
<style scoped>
input, select, textarea{
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    color: black;
}

#admin li{
  font-family: 'Courier New', Courier, monospace;
}


#admin ul li{
  text-align: center;
  -ms-flex-item-align: center;
      -ms-grid-row-align: center;
      align-self: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.loginButton{
  margin-top: 1.5em;
  -ms-flex-item-align: center;
      -ms-grid-row-align: center;
      align-self: center;
  font-family: 'Courier New', Courier, monospace;
  background: white;
  color: black;
  font-size: 15px;
  width: 30%;
  -webkit-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
}

.loginButton:hover{
  width:80%;
}

.chooseOption{
  border-top:1px solid white;
  margin-top: 1em;
  display: -ms-grid;
  display: grid;
  -ms-grid-columns:1fr 1fr;
  grid-template-columns:1fr 1fr;
}

.chooseOption button,.chooseEntry button{
  margin-top: 1em;
  font-family: 'Courier New', Courier, monospace;
}

.chooseEntry{
  display: -ms-grid;
  display: grid;
  -ms-grid-columns:1fr 1fr 1fr;
  grid-template-columns:1fr 1fr 1fr;
}

.listGrid{
  display: -ms-grid;
  display: grid;
  -ms-grid-columns:1fr 1fr;
  grid-template-columns:1fr 1fr;
}

.listName{
  text-align: right;
}

.listDelete{
  text-align: left; 
}

.listDelete:hover{
  background: red;
  color: white;
}

.errorMessage{
  margin-top: 2em;
  font-family: 'Courier New', Courier, monospace;
  text-align: center;
}

.fadeLogin-enter-active{
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  -webkit-transition-delay: 0.6s;
       -o-transition-delay: 0.6s;
          transition-delay: 0.6s;
}
.fadeLogin-leave-active {
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.fadeLogin-enter {
  opacity: 0;
}
.fadeLogin-leave-to {
  opacity: 0;
}


</style>